import { Route, Routes } from "react-router-dom";
import DistrictCreateScreen from "screens/App/CRM/Locations/District/DistrictCreateScreen";
import DistrictDetailScreen from "screens/App/CRM/Locations/District/DistrictDetailScreen";
import DistrictEditScreen from "screens/App/CRM/Locations/District/DistrictEditScreen";
import DistrictListScreen from "screens/App/CRM/Locations/District/DistrictListScreen";
import NotFoundScreen from "screens/NotFoundScreen";

const DistrictRoute = () => {
  return (
    <Routes>
      <Route path="create" element={<DistrictCreateScreen />} />
      <Route path="list" element={<DistrictListScreen />} />
      <Route path=":id/edit" element={<DistrictEditScreen />} />
      <Route path=":id/detail" element={<DistrictDetailScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default DistrictRoute;
